import camelCase from 'lodash/camelCase';
import kebabCase from 'lodash/kebabCase';
import snakeCase from 'lodash/snakeCase';

export const deepCamelCaseKeys = deepTransformKeys.bind(null, camelCase);
// const camelToSnake = deepTransformKeys.bind(null, snakeCase)

export function deepTransformKeys(fn, obj) {
  if (Array.isArray(obj)) {
    return obj.map((item) => deepTransformKeys(fn, item));
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((result, key) => {
      const transformedKey = fn(key);
      result[transformedKey] = deepTransformKeys(fn, obj[key]);
      return result;
    }, {});
  } else {
    return obj;
  }
}

export function transformKeys<T>(fn: (x: string)=> string, obj: object): T {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      return { ...acc, [fn(key)]: value };
    }, {}) as T;
  }

export function kebabCaseKeys<T>(obj: object) {
    return transformKeys<T>(kebabCase, obj)
}
export function snakCaseKeys<T>(obj: object) {
    return transformKeys<T>(snakeCase, obj)
}
export function camelCaseKeys<T>(obj: object) {
    return transformKeys<T>(camelCase, obj)
}